/* global Swiper, attachEvent */
const gallerySliderElements = document.querySelectorAll('[data-slider="gallery-slider"]');

// *******************************************************************************
// Gallery Slider
// *******************************************************************************

const gallerySliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 20,
  mousewheel: {
    releaseOnEdges: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    1199: {
      spaceBetween: 40,
    },
  },
};

gallerySliderElements.forEach((el) => {
  const gallerySliderParent = el.closest('.gallery-slider');
  const paginationElement = gallerySliderParent.querySelector('.swiper-pagination');
  const arrowRight = gallerySliderParent.querySelector('.arrow-right');
  const arrowLeft = gallerySliderParent.querySelector('.arrow-left');

  gallerySliderOptions.pagination.el = paginationElement;
  gallerySliderOptions.navigation.nextEl = arrowRight;
  gallerySliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-new
  new Swiper(el, gallerySliderOptions);
});

// *******************************************************************************
// Open Gallery Modal
// *******************************************************************************

attachEvent('.gallery-slider__item', 'click', (ev) => {
  const parent = ev.target.closest('.gallery-slider');
  const galleryModal = parent.querySelector('.gallery-modal');
  galleryModal.classList.add('is-open-gallery-modal');
});
